import React from 'react';
import tpl from '../templates/credits_new';
import {View} from 'MWC';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state
        };
    }

    static displayName = 'Credit.Views.List';
}
